'use strict';

import React, {Component} from 'react';

import PropTypes from 'prop-types';

import SliderRange from '@uw-it-sis/lib-react/lib/SliderRange';
import moment from 'moment';
import classNames from 'classnames';
import {observer} from "mobx-react";

import courseSearchStore from './CourseSearchStore';

/**
 * Select a time range.
 */
class TimeRangeSelector extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.store = courseSearchStore;

        this.state = {
            startEndTimes: this.props.startEndTimes //this.store.data.formData.startEndTimes
        };

        this.onChange = this.onChange.bind(this);
        this.onAfterChange = this.onAfterChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.startEndTimes !== prevProps.startEndTimes) {
            this.setState({startEndTimes: this.props.startEndTimes})
        }
    }

    /**
     * Called each time the values change.
     */
    onChange = (values) => this.setState({startEndTimes: values});

    /**
     * Called after releasing a slider (i.e. it has been moved).
     */
    onAfterChange = () => this.store.updateCourseSearchFormData("startEndTimes", this.state.startEndTimes);

    /**
     * Utility function to format times.
     */
    _rawMinutesToTime(rawTime) {
        let startTime = moment.utc(0).add({hours: 6, minutes: 30});
        let adjustedTime = startTime.add(rawTime, 'minutes');
        return adjustedTime.format("h:mm a");
    }

    render() {
        return (
            <div className="slider-container">
                <div className={classNames("slider-label", {"disabled": this.props.disabled})}
                     aria-live="polite">
                    <span className="sr-only">Meeting times between:</span>
                    <span>{this._rawMinutesToTime(this.state.startEndTimes[0])}</span>
                    <span className="sr-only"> and </span>
                    <span aria-hidden={true}> &mdash; </span>
                    <span>{this._rawMinutesToTime(this.state.startEndTimes[1])}</span>
                </div>
                <div className="slider-component">
                    <SliderRange
                        min={0}
                        max={960}
                        step={10}
                        allowCross={false}
                        pushable={30}
                        value={this.state.startEndTimes}
                        onChange={this.onChange}
                        onAfterChange={this.onAfterChange}
                        disabled={this.props.disabled}
                        handleEnterKeyPress={this.props.handleEnterKeyPress}
                        handleFormatter={this._rawMinutesToTime}
                        ariaLabelForHandle="Meeting time range selector"/>
                </div>
            </div>
        );
    }
}

TimeRangeSelector.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleEnterKeyPress: PropTypes.func,
    startEndTimes: PropTypes.array
};

TimeRangeSelector.defaultProps = {
    startEndTimes: [0, 960]
}

export default observer(TimeRangeSelector);